<template>
    <div class="mask-bg">
         <div class="login-box hb-box">
          <div class="title">
             <div v-if="isWin">
                恭喜您获得
             </div>
             <div v-else>
              太遗憾了
             </div>
          </div>
          <div class="mount-box">
             <span>{{ amount }}</span>元
          </div>
          <div  class="tip-box">
            <div v-show="!isWin">再接再厉，下次好运一定属于你！</div>
          </div>
          <div class="final-agine" @click="close">继续抽奖</div>
         </div>
    </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      default: 0
    },
    isWin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    boxHeightRem() {
      return this.innerHeightRem;
    },
  },
  components: {
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close','showFinalModal')
    },
  },

  watch: {
  }
};
</script>

<style scoped>
.mask-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.60);
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 311px;
  margin: 0 auto;
  border-radius: 8px;
  background: #DF363A url('./../assets/img/bigWheel/bg_zp_hb.png') no-repeat center top / 100% auto;
}

.hb-box {
  display: flex;
  width: 311px;
  height: 370px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.title {
  margin-top: 100.5px;
  color: #F5EB30;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.mount-box {
  color: #FFF;
  font-size: 24px;
  font-weight: 600;
}

.mount-box>span {
  font-size: 48px !important;
  padding-right: 7px;
}

.tip-box {
  color: #FFFEE5;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 8px 0 17px ;
}

.final-agine {
  width: 136px;
  height: 35px;
  line-height: 31px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(177deg, #FFF53B 0.99%, #FFCB0B 95.75%);
  box-shadow: 0px -4px 0px 0px #FD8B14 inset;

  text-align: center;
  color: #D40708;
font-family: "PingFang SC";
font-size: 14px;
font-style: normal;
font-weight: 500;
}
</style>